var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        "destroy-on-close": true,
        size: "1060px",
        visible: _vm.dialogVisible,
        title: _vm.tabs.length > 1 ? "" : _vm.title,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _vm._t("title", null, { slot: "title" }),
      _c("yxtbiz-range-selector", {
        ref: "selector",
        class: [
          "gwnl-personality-select",
          _vm.hideV2BizTitle ? "gwnl-personality-select--no-header" : "",
        ],
        attrs: {
          limit: _vm.limit,
          tabs: _vm.tabsV2,
          "function-code": _vm.functionCode,
          "data-permission-code": _vm.dataPermissionCode,
        },
        on: { change: _vm.changeUsers },
        model: {
          value: _vm.bindData,
          callback: function ($$v) {
            _vm.bindData = $$v
          },
          expression: "bindData",
        },
      }),
      _vm._t("content"),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_gwnl_global_btn_cancel")) +
                  "\n    "
              ),
            ]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.getUsers } },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("pc_gwnl_global_btn_confirm")) +
                  "\n    "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }